import { ReactComponent as InformationCircleFilled } from './information-circle-filled.svg';
import { ReactComponent as ExclamationCircleFilled } from './exclamation-circle-filled.svg';
import { ReactComponent as CheckCircleFilled } from './check-circle-filled.svg';
import { ReactComponent as CrossCircleFilled } from './cross-circle-filled.svg';
import { ReactComponent as Cross } from './cross.svg';
import { ReactComponent as Arrow } from './arrow.svg';
import { ReactComponent as Plus } from './plus.svg';
import { ReactComponent as Minus } from './minus.svg';
import { ReactComponent as Trash } from './trash.svg';
import { ReactComponent as Chevron } from './chevron.svg';
import { ReactComponent as Play } from './play.svg';
import { ReactComponent as CirclePlay } from './circle-play.svg';
import { ReactComponent as Pause } from './pause.svg';
import { ReactComponent as VolumeMedium } from './volume-medium.svg';
import { ReactComponent as VolumeOff } from './volume-off.svg';
import { ReactComponent as CirclePause } from './circle-pause.svg';
import { ReactComponent as Dots } from './dots.svg';
import { ReactComponent as ArrowReturnLeft } from './arrow-return-left.svg';
import { ReactComponent as Wifi } from './wifi.svg';

export const Icons = {
  InformationCircleFilled,
  ExclamationCircleFilled,
  CheckCircleFilled,
  CrossCircleFilled,
  Cross,
  Arrow,
  Plus,
  Minus,
  Trash,
  Chevron,
  Play,
  CirclePlay,
  Pause,
  VolumeMedium,
  VolumeOff,
  CirclePause,
  Dots,
  ArrowReturnLeft,
  Wifi,
};
